var $f12d8c9bdaa0bcb1$exports = {};
$f12d8c9bdaa0bcb1$exports = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de n\xfamero`
};


export {$f12d8c9bdaa0bcb1$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
